<template>
  <ButtonComponent
    id="request_microsoft_login"
      :variant="$props.variant"
      :text="buttonText[$props.type][$props.lang]"
      :image="'https://cdn.systemico.net/abc/icons/microsoft.svg'"
      @click="loginWithGoogle()"
      style="display: inline; min-width:280px;"
      class="text-left"
  >
  </ButtonComponent>
</template>
<script>
import ButtonComponent from './ButtonComponent.vue';
export default {
  name: 'ButtonMicrosoftLogin',
  components:{
    ButtonComponent
  },
  props: {
    variant: String,
    lang: {
      type: String,
      default: 'EN'
    },
    type: {
      type: String,
      default: 'LOGIN'
    }
  },
  data () {
    return {
      buttonText: {
        LOGIN: {
          EN: 'Sign in <b>with Microsoft</b>',
          ES: 'Iniciar <b>con Microsoft</b'
        },
        SIGNUP: {
          EN: 'Sign up <b>with Microsoft</b>',
          ES: 'Regístrate <b>con Microsoft</b'
        }
      }
    }
  },
  beforeMount() {
    if (this.lang !== 'EN' && this.lang !== 'ES') {
      this.lang = 'EN'
    }
  },
  methods: {
    loginWithGoogle(){
      // REDIRECT SITE
      window.location.href = 'href="/api/glogin/validate"';
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../variables.scss";
</style>
